var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("insert.warehouse.status")) + ":")
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rowData.StatusId
                              ? _vm.$t("insert.active")
                              : _vm.$t("insert.passive")
                          )
                      )
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("get.detail"), active: "" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-3 asc__showPage-card" },
                              [
                                _c("h6", [
                                  _vm._v(_vm._s(_vm.$t("get.detail")))
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("get.terminal.Branch"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.Branch
                                        ? _vm.rowData.Branch.Label
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.OperationType")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.TerminalOperationType
                                        ? _vm.rowData.TerminalOperationType
                                            .Label
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.Representative")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.Representative
                                        ? _vm.rowData.Representative.Label
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.OperationState")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.TerminalOperationState
                                        ? _vm.rowData.TerminalOperationState
                                            .Label
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.TransferMethod")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.TerminalTransferMethod
                                        ? _vm.rowData.TerminalTransferMethod
                                            .Label
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.OperationDate")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.OperationDate
                                        ? _vm.dateConvertFromTimezone(
                                            _vm.rowData.OperationDate
                                          )
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.OperationTime")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.OperationTime
                                        ? _vm.rowData.OperationTime
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.TerminalVersion")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.TerminalVersion
                                        ? _vm.rowData.TerminalVersion
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "get.terminal.TransferAppVersion"
                                        )
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.TransferAppVersion
                                        ? _vm.rowData.TransferAppVersion
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("get.terminal.UserDate"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.UserDate
                                        ? _vm.dateConvertFromTimezone(
                                            _vm.rowData.UserDate
                                          )
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.TransferFileName")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.TransferFileName
                                        ? _vm.rowData.TransferFileName
                                        : ""
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", { staticClass: "far fa-circle" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("get.terminal.ErrorMessage")
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.rowData.ErrorMessage
                                        ? _vm.rowData.ErrorMessage
                                        : ""
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2713310a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2713310a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TerminalLog/get.vue
// module id = null
// module chunks = 